import { createSelector } from '@ngrx/store';
import { getDragonflyState } from '../reducers';
import { assignCheckbookAdapter } from '../reducers/assign-checkbook.reducer';

export const getAssignCheckbookState = createSelector(getDragonflyState, (state) => state?.assignCheckbook);

export const getDisplayedColumnKeys = createSelector(getAssignCheckbookState, (state) =>
  Object.keys(state?.displayedColumns ?? {}),
);

export const getDisplayedColumns = createSelector(getAssignCheckbookState, (state) => state?.displayedColumns);

export const assignCheckbookSelectors = assignCheckbookAdapter.getSelectors();

export const getMembersData = createSelector(getAssignCheckbookState, assignCheckbookSelectors.selectAll);

export const getSearch = createSelector(getAssignCheckbookState, (state) => state?.search);

export const getValidUntilDate = createSelector(getAssignCheckbookState, (state) => state?.validUntilDate);

export const getValidUntilDateFormat = createSelector(getAssignCheckbookState, (state) => state?.validUntilDateFormat);

export const getShowTable = createSelector(getAssignCheckbookState, (state) => state?.showTable);

export const getSchema = createSelector(getAssignCheckbookState, (state) => state?.schema);

export const getLoyaltyMemberId = createSelector(getAssignCheckbookState, (state) => state?.loyaltyMemberId);

export const getAssignCheckbookDataIsSubmitted = createSelector(
  getAssignCheckbookState,
  (state) => state?.isSubmittedData,
);

export const getShowCheckbookNumberErrorMsg = createSelector(
  getValidUntilDate,
  getAssignCheckbookDataIsSubmitted,
  (date, dataIsSubmitted) => (!date && dataIsSubmitted ? true : false),
);

export const getAssignCheckbookDataAreValid = createSelector(getValidUntilDate, (date) => {
  return date ? true : false;
});
